//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z0046vst on 08.03.2023.
 */

 (function () {

    'use strict';

    angular
        .module('container.core')
        .factory('tokenExchangeService', tokenExchangeService)
        ;

    function tokenExchangeService($q) {
        let keycloakService = window._keycloak;

        let service = {};

        service.getExchangeToken = function (token) {
            let promise = $q.defer();
    
            let params = 'grant_type=urn:ietf:params:oauth:grant-type:token-exchange';
            params += '&requested_token_type=urn:ietf:params:oauth:token-type:access_token';
            params += '&subject_token=' + token;
            params += '&client_id=' + encodeURIComponent('operator-client-launcher');
            params += '&client_secret=';

            let url = getKeycloakExchangeTokenUrl();
            console.info('keycloak url:' + url);

            let req = new XMLHttpRequest();
            req.open('POST', url, true);

            req.onreadystatechange = function () {
                if (req.readyState == 4) {
                    if (req.status == 200) {
                        console.log("Success of request for operator-client-launcher token.");
                        let jsonObject = JSON.parse(req.responseText);
                        let exchangeToken = jsonObject['access_token'];
                        promise.resolve(exchangeToken);
                        return;
                    } else {
                        console.log("Fail of request for operator-client-launcher token! The original token is used.");
                        promise.resolve(token);
                        return;
                    }
                }
            };

            req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            req.withCredentials = true;
            req.send(params);
    
            return promise.promise;
        }   
        
        return service;
    }

    function getKeycloakExchangeTokenUrl() {
        if (typeof window._keycloak.authServerUrl !== 'undefined') {
            if (window._keycloak.authServerUrl.charAt(window._keycloak.authServerUrl.length - 1) == '/') {
                return window._keycloak.authServerUrl + 'realms/' + window._keycloak.realm + "/protocol/openid-connect/token";
            } else {
                return window._keycloak.authServerUrl + '/realms/' + window._keycloak.realm + "/protocol/openid-connect/token";
            }
        } else {
            return undefined;
        }
    }
})();